import React, { useEffect } from 'react';
import AOS from 'aos';
import { Trans, useTranslation } from 'react-i18next'; // 1. Imports
import 'aos/dist/aos.css';
import './TrasladosPage.css';
import ContactButton from '../../../atoms/ContactButton/ContactButton';
import trasladosHero from '../../../../assets/traslados-hero.png';

const TrasladosPage: React.FC = () => {
  // 2. Hook
  const { t } = useTranslation();

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  // 3. Helper para obtener listas (includes)
  const getList = (key: string) => {
    const list = t(key, { returnObjects: true });
    return Array.isArray(list) ? list : [];
  };

  return (
    <div className="traslados-page-container">
      {/* --- Hero Section --- */}
      <header
        className="traslados-hero"
        style={{ backgroundImage: `url(${trasladosHero})` }}
      >
        <div className="hero-overlay"></div>
        <h1 className="hero-title" data-aos="fade-up">
           <Trans i18nKey="transfersPage:heroTitle" />
        </h1>
      </header>

      {/* --- Intro Section --- */}
      <section className="traslados-intro">
        <div className="intro-content" data-aos="fade-up">
          <h2 className="intro-title">
             <Trans i18nKey="transfersPage:intro.title" components={{ br: <br /> }} />
          </h2>
          <p className="intro-subtitle">
            <Trans 
              i18nKey="transfersPage:intro.description" 
              components={{ strong: <strong /> }}
            />
          </p>
        </div>
      </section>

      {/* --- Opciones Section --- */}
      <section className="traslados-options">
        <div className="options-grid">

          {/* Cancún */}
          <div className="option-card" data-aos="fade-up" data-aos-delay="100">
            <h3 className="option-title"><Trans i18nKey="transfersPage:options.cancun.title" /></h3>
            <p className="option-subtitle"><Trans i18nKey="transfersPage:options.cancun.subtitle" /></p>
            <div className="service-divider"></div>

            {/* Terrestre (Cancún) */}
            <div className="service-block">
              <h4 className="service-title"><Trans i18nKey="transfersPage:options.cancun.land.title" /></h4>
              <p className="service-details">
                <Trans 
                  i18nKey="transfersPage:options.cancun.land.details"
                  components={{ br: <br />, strong: <strong /> }}
                />
              </p>
              <p className="service-note"><Trans i18nKey="transfersPage:options.cancun.land.note" /></p>
              <div className="service-includes">
                <p><Trans i18nKey="transfersPage:options.cancun.land.includesTitle" /></p>
                <ul>
                  {getList('transfersPage:options.cancun.land.includes').map((item, i) => (
                    <li key={i}>{item as string}</li>
                  ))}
                </ul>
              </div>
            </div>

            {/* Avioneta (Cancún) */}
            <div className="service-block avioneta-service" data-aos="fade-up" data-aos-delay="200">
              <div className="service-divider"></div>
              <h4 className="service-title"><Trans i18nKey="transfersPage:options.cancun.air.title" /></h4>
              <p className="service-details"><Trans i18nKey="transfersPage:options.cancun.air.details" /></p>
              <div className="service-includes">
                <p><Trans i18nKey="transfersPage:options.cancun.air.includesTitle" /></p>
                <ul>
                  {getList('transfersPage:options.cancun.air.includes').map((item, i) => (
                    <li key={i}>{item as string}</li>
                  ))}
                </ul>
                <p><Trans i18nKey="transfersPage:options.cancun.air.luggageNote" /></p>
              </div>
              <ContactButton />
            </div>
          </div>

          {/* Mérida */}
          <div className="option-card" data-aos="fade-up" data-aos-delay="200">
            <h3 className="option-title"><Trans i18nKey="transfersPage:options.merida.title" /></h3>
            <p className="option-subtitle"><Trans i18nKey="transfersPage:options.merida.subtitle" /></p>
            <div className="service-divider"></div>
            <h4 className="service-title"><Trans i18nKey="transfersPage:options.merida.land.title" /></h4>
            <p className="service-details">
              <Trans 
                  i18nKey="transfersPage:options.merida.land.details"
                  components={{ br: <br />, strong: <strong /> }}
              />
            </p>
            <p className="service-note"><Trans i18nKey="transfersPage:options.merida.land.note" /></p>
            <div className="service-includes">
              <p><Trans i18nKey="transfersPage:options.merida.land.includesTitle" /></p>
              <ul>
                 {getList('transfersPage:options.merida.land.includes').map((item, i) => (
                    <li key={i}>{item as string}</li>
                  ))}
              </ul>
            </div>
            <ContactButton />
          </div>

          {/* Riviera Maya */}
          <div className="option-card" data-aos="fade-up" data-aos-delay="300">
            <h3 className="option-title"><Trans i18nKey="transfersPage:options.riviera.title" /></h3>
            <p className="option-subtitle"><Trans i18nKey="transfersPage:options.riviera.subtitle" /></p>
            <div className="service-divider"></div>
            <h4 className="service-title"><Trans i18nKey="transfersPage:options.riviera.land.title" /></h4>
            <p className="service-details">
               <Trans 
                  i18nKey="transfersPage:options.riviera.land.details"
                  components={{ br: <br />, strong: <strong /> }}
              />
            </p>
            <p className="service-note"><Trans i18nKey="transfersPage:options.riviera.land.note" /></p>
            <div className="service-includes">
              <p><Trans i18nKey="transfersPage:options.riviera.land.includesTitle" /></p>
              <ul>
                 {getList('transfersPage:options.riviera.land.includes').map((item, i) => (
                    <li key={i}>{item as string}</li>
                  ))}
              </ul>
            </div>
            <ContactButton />
          </div>
        </div>
      </section>
    </div>
  );
};

export default TrasladosPage;